import { DotsHorizontalIcon } from '@radix-ui/react-icons';
import { Button } from '@wolfejs/ui/Button';
import { Title } from '@wolfejs/ui/Title';
import { cn } from '@wolfejs/ui/utils/classnames';
import type { ReportItemProps } from './types';

export const ReportItem = ({ name, description, icon }: ReportItemProps) => {
  return (
    <div className={cn('border-default-200 relative flex gap-3 border-b pb-4')}>
      <div className="bg-default-100 flex h-9 w-9 items-center justify-center rounded-lg">{icon}</div>
      <div className="flex flex-col">
        <Title as="h5" className="text-default-900 dark:text-default-500 mb-0 text-base">
          {name}
        </Title>
        <div className="text-default-500 dark:text-default-400 text-sm">{description}</div>
      </div>
      <Button className="absolute right-0" shape="circle" size="sm" variant="ghost">
        <DotsHorizontalIcon className="h-4 w-4" />
      </Button>
    </div>
  );
};
